import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';
import i18n from '@/lang/i18n';
import FirmwareVersionAutoComplete from '@/components/AutoCompletes/FirmwareVersionAutoComplete.vue';
import FirmwareVersionsType from '@/types/FirmwareVersionsType';


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateVersion',
  props: {
    modelValue: {},
    initialItemId: {},
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props

const firmware = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
})


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "fw-bold" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.firmwareBulkUpdate.firmwareVirsion.name')) + " ", 1),
            _cache[1] || (_cache[1] = _createElementVNode("span", { style: {"color":"red"} }, "✴︎", -1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(FirmwareVersionAutoComplete, {
              modelValue: firmware.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((firmware).value = $event)),
              initialItemId: props.initialItemId,
              errorMessages: props.errorMessages
            }, null, 8, ["modelValue", "initialItemId", "errorMessages"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})